"use client"

import { useTheme } from "next-themes"
import { useEffect, useState } from "react"

export function Logo() {
  const { theme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Don't render anything until mounted to avoid hydration mismatch
  if (!mounted) {
    return (
      <div className="h-6 w-16 bg-muted animate-pulse rounded" />
    )
  }

  // Use resolvedTheme for more accurate theme detection (handles 'system' theme)
  const isDark = resolvedTheme === 'dark'

  return (
    <div className="logo-container">
      <img 
        src={isDark ? "/erp_logo_dark.svg" : "/erp_logo_light.svg"}
        alt="TMG ERP" 
        className="logo-responsive"
      />
    </div>
  )
}
